export const ACTION_TYPES = {
  GET_NOTIFICATIONS_REQUEST: 'GET_NOTIFICATIONS_REQUEST',
  GET_NOTIFICATIONS_SUCCESS: 'GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_FAILURE: 'GET_NOTIFICATIONS_FAILURE',
  GET_MORE_NOTIFICATIONS_REQUEST: 'GET_MORE_NOTIFICATIONS_REQUEST',
  GET_MORE_NOTIFICATIONS_SUCCESS: 'GET_MORE_NOTIFICATIONS_SUCCESS',
  GET_MORE_NOTIFICATIONS_FAILURE: 'GET_MORE_NOTIFICATIONS_FAILURE',
  DELETE_NOTIFICATION_REQUEST: 'DELETE_NOTIFICATION_REQUEST',
  DELETE_NOTIFICATION_SUCCESS: 'DELETE_NOTIFICATION_SUCCESS',
  DELETE_NOTIFICATION_FAILURE: 'DELETE_NOTIFICATION_FAILURE',
  UPDATE_NOTIFICATION_REQUEST: 'UPDATE_NOTIFICATION_REQUEST',
  UPDATE_NOTIFICATION_SUCCESS: 'UPDATE_NOTIFICATION_SUCCESS',
  UPDATE_NOTIFICATION_FAILURE: 'UPDATE_NOTIFICATION_FAILURE',
  UPDATE_QUERY_STATE: 'UPDATE_QUERY_STATE',
  UPDATE_TOTAL_UNREAD_COUNT: 'UPDATE_TOTAL_UNREAD_COUNT',
  UPDATE_ONE_NOTIFICATION: 'UPDATE_ONE_NOTIFICATION',
  NEW_FCM_NOTIFICATION: 'NEW_FCM_NOTIFICATION',
  NEW_SOCKET_NOTIFICATION: 'NEW_SOCKET_NOTIFICATION',
  SET_UNREAD_COUNT: 'SET_UNREAD_COUNT',
  SYNC_NOTIFICATIONS_REQUEST: 'SYNC_NOTIFICATIONS_REQUEST',
  SYNC_NOTIFICATIONS_SUCCESS: 'SYNC_NOTIFICATIONS_SUCCESS',
  SYNC_NOTIFICATIONS_FAILURE: 'SYNC_NOTIFICATIONS_FAILURE',
};

export const FCM_EVENT_ACTION_TYPES = {
  TASK_ASSIGNMENT: 'taskAssignment',
  TASK_UPDATE: 'taskUpdate',
  TASK_COMMENT: 'taskComment',
  CHAT_REPLY: 'chatReply',
  INVITATION: 'invitation',
  WORKSPACE_INVITED: 'workspaceInvited',
};

export const NOTIFICATION_TYPES = {
  TASK_NOTIFICATION: 'TaskNotification',
  COMMENT_NOTIFICATION: 'CommentNotification',
  CHAT_NOTIFICATION: 'ChatNotification',
  CHAT_REPLY_NOTIFICATION: 'ChatReplyNotification',
  INVITE_NOTIFICATION: 'InviteNotification',
  PROJECT_JOINED_NOTIFICATION: 'ProjectJoinedNotification',
  WORKSPACE_JOINED_NOTIFICATION: 'WorkspaceJoinedNotification',
};

export const ACTIVITY_FILTERS = ['All', 'Task', 'Mentions', 'Threads', 'AssignedToMe'];
